<template>
  <div class="table-overflow">
    <table :class="[tableClass, useFooter == false ? 'no-footer' : '', tdAuto == true ? 'td-auto' : '']">
      <thead>
        <th
          v-for="column in columns"
          :key="column.name"
          :class="headCentered && 'text-center'"
        >
          {{ column.name }}
        </th>
      </thead>
      <tbody>
        <tr v-if="useFilter == true">
          <td v-for="column in columns" :key="column.key">
            <input type="text" :placeholder="column.name" @input="(event) => {
              searchTerm = event.target.value;
              columnToFilter = event.target.value != '' ? column.key : '';
              filterData()
            }">
          </td>
        </tr>
        <tr v-for="item in clonedData" :key="item.id" @click="trAction(item)">
          <td v-for="({ name, key, ...props }) in columns" :key="name" :class="cellCentered && 'text-center'">
            <slot :name="key" :item="item" v-if="$scopedSlots[key]"></slot>
            <span v-else-if="key && !$scopedSlots[key]">
              <span v-if="props.isDate === true && props.isMultipleKey === undefined">
                {{ traverse(item, key) | moment("DD/MM/YYYY") }}
              </span>
              <span v-else-if="props.isArray === true && props.keyArray">
                {{ traverseArray(item, key, props.keyArray) }}
              </span>
              <span v-else-if="props.isDate && props.isMultipleKey === true">
                {{ traverseMultipleDate(item, key) }}
              </span>
              <span v-else-if="props.isMoney && props.isMultipleKey === undefined">
                {{ moneyFormat(traverse(item, key)) }}
              </span>
              <span v-else-if="props.isMoney && props.isMultipleKey === true">
                {{ traverseMultipleMoney(item, key) }}
              </span>
              <span v-else-if="props.isMultipleKey === true">
                {{ traverseMultiple(item, key) }}
              </span>
              <span v-else-if="key === 'duimp'" class="text-bold">
                {{ traverseBoolean(item, key) }}
              </span>
              <span v-else-if="key === 'identification'" class="text-bold">
                {{ traverse(item, key) }}
              </span>
              <span v-else>
                {{ traverse(item, key) }}
              </span>
            </span>
            <div class="flex" v-else-if="key == 'actions' && actions">
              <slot name="actions" :item="item"></slot>
            </div>
          </td>
        </tr>
        <tr v-if="clonedData.length <= 0">
          <td :colspan="columns.length">
            <h4 class="text-center">
              Nenhum registro até o momento
            </h4>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="useFooter == true">
        <th :colspan="columns.length">
          <slot name="footer"></slot>
        </th>
      </tfoot>
    </table>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Table',
  // computed: {
  //   filteredData() {
  //     return this.data.filter((item) => String(item[`${this.columnToFilter}`]).match(new RegExp(this.searchTerm, 'gi')));
  //   },
  // },
  data() {
    return {
      searchTerm: '',
      columnToFilter: '',
      columnToSort: '',
      sortDirection: '',
      clonedData: this.data,
    };
  },
  methods: {
    traverseBoolean(obj, keys) {
      const value = keys.split('.').reduce((cur, key) => cur[key], obj);
      return value ? 'Sim' : 'Não';
    },
    traverse(obj, keys) {
      return keys.split('.').reduce((cur, key) => cur[key], obj);
    },
    traverseArray(obj, keys, keyArray) {
      const value = this.traverse(obj, keys);
      return value ? value.map((item) => item[keyArray]).join(', ') : '';
    },
    filterData() {
      const column = this.columns.find((col) => col.key === this.columnToFilter);
      if (column !== undefined && column.isDate) {
        this.clonedData = this.data.filter((item) => moment(item[`${this.columnToFilter}`]).format('DD/MM/YYYY').match(new RegExp(this.searchTerm, 'gi')));
      } else {
        this.clonedData = this.data.filter((item) => String(item[`${this.columnToFilter}`]).match(new RegExp(this.searchTerm, 'gi')));
      }
    },
    traverseMultiple(obj, keys) {
      for (const key of keys) {
        const valueField = obj[key.field];
        if (valueField !== undefined) {
          if (key.valueValidation === undefined) {
            return valueField;
          }
          if (key.valueValidation !== undefined) {
            const valueFieldValidate = obj[key.fieldValidate];
            if (key.valueValidation === false && (valueFieldValidate === null || valueFieldValidate === false)) {
              return obj[key.field];
            } if (key.valueValidation === true && valueFieldValidate === true) {
              return obj[key.field];
            }
          }
        }
      }
      return '';
    },
    traverseMultipleDate(obj, keys) {
      for (const key of keys) {
        const valueField = obj[key.field];
        if (valueField !== undefined) {
          if (key.valueValidation === undefined) {
            return moment(valueField).format('DD/MM/YYYY');
          }
          if (key.valueValidation !== undefined) {
            const valueFieldValidate = obj[key.fieldValidate];
            if (key.valueValidation === false && (valueFieldValidate === null || valueFieldValidate === false)) {
              return valueField ? moment(valueField).format('DD/MM/YYYY') : '';
            } if (key.valueValidation === true && valueFieldValidate === true) {
              return valueField ? moment(valueField).format('DD/MM/YYYY') : '';
            }
          }
        }
      }
      return '';
    },
    traverseMultipleMoney(obj, keys) {
      for (const key of keys) {
        const valueField = obj[key.field];
        if (valueField !== undefined) {
          if (key.valueValidation === undefined) {
            return this.moneyFormat(valueField);
          }
          if (key.valueValidation !== undefined) {
            const valueFieldValidate = obj[key.fieldValidate];
            if (key.valueValidation === false && (valueFieldValidate === null || valueFieldValidate === false)) {
              return valueField ? this.moneyFormat(valueField) : '';
            } if (key.valueValidation === true && valueFieldValidate === true) {
              return valueField ? this.moneyFormat(valueField) : '';
            }
          }
        }
      }
      return '';
    },
  },
  watch: {
    data: {
      handler(val) {
        this.clonedData = val;
      },
      deep: true,
    },
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    trAction: {
      type: Function,
      default: () => {},
    },
    actions: {
      type: Boolean,
      default: false,
    },
    tableClass: {
      type: String,
      default: '',
    },
    headCentered: {
      type: Boolean,
      default: false,
    },
    cellCentered: {
      type: Boolean,
      default: false,
    },
    useFooter: {
      type: Boolean,
      default: false,
    },
    useFilter: {
      type: Boolean,
      default: false,
    },
    tdAuto: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
  input[type="text"] {
    font-size: 0.8rem;
  }

  tr td {
    transition: var(--all-transition);
  }

  tr:hover td {
    background-color: var(--light-bg-color);
  }
</style>
